import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';

@Component({
  selector: 'app-category-menu',
  templateUrl: './category-menu.component.html',
  // styleUrls: ['./category-menu.component.scss'],
})
export class CategoryMenuComponent implements OnInit {
  @Input() allCategoriesForWebsite: any[] = [];
  @Input() CATEGORY_IMAGE_PATH: string = '';
  @Input() foodCovor: string = '';
  @Output() categorySelected = new EventEmitter<any>();

  searchTerm: string = '';
  filteredCategories: any[] = [];

  constructor(private menuController: MenuController) { }

  ngOnInit() {
    this.filteredCategories = Array.from(this.allCategoriesForWebsite);
  }

  async openMenu() {
    await this.menuController.open('category-menu');
  }
}
